// extracted by mini-css-extract-plugin
export default {"Mascot":"Mascot-module__Mascot--pjmse","Animate":"Mascot-module__Animate--c876P","Image":"Mascot-module__Image--CxUCL","Shadow":"Mascot-module__Shadow--Ubbq8"};